import React, {Component} from 'react';
import {Button, Radio,Popconfirm} from "antd"
import ZkTable from "../../common/table/zkTable";
import CorpApi from "../../public/corp_api";
import ZkStatus from "../../cloud/common/zkStatus/zkStatus";
import ZkModal from "../../common/modal/zkModal";
import ZkFormItem from "../../common/form/zkFormItem";
import {DefaultUploadFile} from "../../cmpts/uploadfile";
import Message from "../../common/message";
import Util from "../../public/utils";
import {
    URL_ORDER_BULK_DELIVER_DOWN_LOAD_FAIL,
} from "../../public/variables";

class Batchdeliver extends Component {
    constructor(props) {
        super(props);
        this.state={
            uploading:false
        }
    }
    //表格样式
    getColumns=()=>{
        return [{
            dataIndex: 'id',
            title:'发货编号',
            fixed: 'left',
            width: '100px',
            render:(text,record)=>(
                <span>{record.id}</span>
            )
        },{
            dataIndex: 'optDate',
            title:'操作时间',
            render:(text,record)=>(
                <span>{record.optDate ? new Date(record.optDate) . format('yyyy-MM-dd hh:mm') : ''}</span>
            )
        },{
            dataIndex: 'status',
            title:'状态',
            render:(text,record)=>(
                <>
                    {
                        record.status == 1 ?
                        <ZkStatus name={'已完成'} iconColor={'#35C859'} fontColor={'#262626'}/> :
                            record.status == 0 ?
                                <ZkStatus name={'处理中'} iconColor={'#ECB500'} fontColor={'#262626'}/> : ''
                    }
                </>
            )
        },{
            dataIndex: 'dTotalNum',
            title:'总发货单数',
            render:(text,record)=>(
                <span>{record.dTotalNum}</span>
            )
        },{
            dataIndex: 'dSuccessNum',
            title:'发货成功单数',
            render:(text,record)=>(
                <span>{record.dSuccessNum}</span>
            )
        },{
            dataIndex: 'dFailNum',
            title:'失败发送单数',
            render:(text,record)=>(
                <span>{record.dFailNum}</span>
            )
        },{
            dataIndex: 'status',
            title:'操作',
            render:(text,record)=>(
                <div>
                    {
                        record.dFailNum > 0 ?
                            <span
                                style={{color:'#1673FF',marginRight:'5px',cursor:'pointer'}}
                                onClick={this.downloadRecord.bind(this,record.id)}
                            >
                                下载失败记录
                            </span> : ''
                    }
                    {
                        record.status == 0 ?
                            <span style={{color:'#959595'}}>删除</span> :
                            <Popconfirm
                                title="确认删除?"
                                onConfirm={this.delList.bind(this,record.id)}
                                okText="确认"
                                cancelText="取消">
                                <span style={{color:'#1673FF',cursor:'pointer'}}>删除</span>
                            </Popconfirm>
                    }
                </div>
            )
        }]
    }

    //下载
    downloadRecord=(id)=>{
        Util.downLoadFile(URL_ORDER_BULK_DELIVER_DOWN_LOAD_FAIL + '?' + 'recordId=' + id)
    }
    //删除表格的数据
    delList=(id)=>{
        let bodyData={
            id
        }
        CorpApi.getOrderDeliverDelete(bodyData,()=>{
            Message.success('删除成功')
            this.recordListRef.refresh() //刷新表格
        },(error)=>{
            //0 40027 直播已经开始不允许上下架
            if(error.respCode == 40027){
                Message.success('直播已经开始不允许上下架')
            }else {
                Message.success('删除失败，请稍后再试')
            }
        })
    }
    //请求表格数据
    getData=(params,pageNum,pageSize)=>{
        return new Promise(resolve => {
            CorpApi.getOrderBulkDeliverRecordList(pageNum,pageSize,(data)=>{
                resolve(data)
            },()=>{})
        })
    }
    //选择上传的文件
    selectFile=(file)=> {
        if (file.length > 0) {
            let fielList = [];
            for(let i = 0; i<file.length; i++){
                fielList.push(file[i])
            }
            this.setState({
                file: fielList
            })
        }
    }
    //确认发货按钮
    confirmDelivery=()=>{
        if(!this.state.file){
            Message.error('请上传发货文件')
        }else {
            this.setState({
                uploading:true
            },()=>{
                let bodyData={
                    orderFile:this.state.file
                }
                CorpApi.getOrderBulkDeliverUploadData(bodyData,(data)=>{
                    this.setState({
                        uploading:false
                    })
                    this.batchDeliverRef.hide() //关闭弹框
                    Message.success('上传成功')
                    this.recordListRef.refresh() //刷新表格
                },()=>{
                    this.setState({
                        uploading:false
                    })
                    Message.error('上传失败，请稍后再试')
                })
            })
        }
    }
    render() {
        return (
            <div className={'batch_deliver_style'}>
                <Button type={'primary'} onClick={()=>this.batchDeliverRef.show()}>批量发货</Button>
                <div style={{marginTop:'20px'}}>
                    <ZkTable
                        ref={r=>this.recordListRef=r}
                        owncolumns={this.getColumns}
                        queryAction={this.getData}
                    />
                </div>
                <ZkModal ref={r => this.batchDeliverRef = r}
                         title={'批量发货'}
                         width={600}
                         className={'modal-right-btn im-setting-modal'}
                         footer={
                    <div>
                        <Button onClick={()=>this.batchDeliverRef.hide()}>取消</Button>
                        <Button type="primary" onClick={this.confirmDelivery} loading={this.state.uploading}>确认发货</Button>
                    </div>
                }>
                    <div className={'batch_deliver_modal'}>
                        <ZkFormItem title={'发货文件'} colon={true} titleWidth={'86px'} conWidth={'431px'}>
                            <div className='itemwarp'>
                                <DefaultUploadFile btnText={this.state.file ? '替换文件' : '选择文件'}
                                                   multiple='multiple'
                                                   selectFile={this.selectFile}
                                                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    />
                            </div>
                            {
                                this.state.file && this.state.file.map((item,index)=>{
                                    return <span className={'lineHeight32'}>{item.name ? item.name : ''}</span>
                                })
                            }
                        </ZkFormItem>
                        <ZkFormItem title={'模版下载'} colon={true} titleWidth={'86px'} conWidth={'431px'}>
                            <div className={'batch_deliver_modal_attention'}>
                                <a href='https://zk-cloud.oss-cn-beijing.aliyuncs.com/static/%E7%B4%AB%E9%B2%B2%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx'>下载批量发货模版</a>
                                <span>*请仔细填写快递公司和快递单号，请勿修改格式</span>
                                <ul>
                                    <li>注意事项</li>
                                    <li>1.批量发货可选择多个发货文件同时发货</li>
                                    <li>2.如果订单没有填写快递信息，也会默认进行发货，只是没有物流信息</li>
                                    <li>3.如果想修改订单的物流信息，修改完成之后重新上传，之前的物流信息会被覆盖</li>
                                </ul>
                            </div>
                        </ZkFormItem>
                    </div>
                </ZkModal>
            </div>
        );
    }
}

export default Batchdeliver;